import _ from 'lodash';
import uuid4 from 'uuid/v4';
import React from 'react';

import Button from 'components/Button';
import Warning from 'components/Warning';
import ErrorBlock from 'components/ErrorBlock';
import {default as Modal, withModal} from 'components/Modal';
import {
  MODALS,
  voidGocardlessInvitationWarnings,
  removeGocardlessInvitation,
  fetchGocardlessCustomerAndInvitation
} from 'ducks/tenancy';
import {closeModal} from 'ducks/modals';

import './styles.css';

class RemoveAndVoidGocardlessInvitationModal extends React.Component<any> {
  componentDidMount() {
    const {invitationId} = this.props.data;

    this.props.voidGocardlessInvitationWarnings(
      {invitationId},
      this.props.storeDataExtraActions(data => ({warnings: data.warnings}))
    );
  }

  voidInvitation = () => {
    const {tenancyId, data: {invitationId}} = this.props;

    const successExtraActions = [
      ...this.props.closeModalExtraActions,
      () => closeModal(MODALS.REMOVE_GOCARDLESS_INVITATION),
      () => fetchGocardlessCustomerAndInvitation({tenancyId})
    ];

    const failureExtraActions = this.props.storeDataExtraActions(errors => ({
      errors
    }));

    this.props.removeGocardlessInvitation(
      {tenancyId, invitationId, voidInvitation: true},
      successExtraActions,
      failureExtraActions
    );
  };

  render() {
    const {warnings, errors} = this.props.data;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="RemoveAndVoidGocardlessInvitationModal"
        type={Modal.SMALL}>
        <Modal.Header>
          <h3 className="heading">Void GoCardless Invitation</h3>
        </Modal.Header>
        <Modal.Body>
          {!_.isEmpty(warnings) &&
            _.map(warnings, warning => {
              return <Warning key={uuid4()}>{warning}</Warning>;
            })}
          {_.isEmpty(warnings) && (
            <Warning>Invitation is not attached to any bookings</Warning>
          )}
          {errors && <ErrorBlock>{errors._error}</ErrorBlock>}
        </Modal.Body>
        <Modal.Footer>
          <Button red onClick={this.voidInvitation}>
            Void
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = () => ({});
const mapDispatchToModalProps = {
  voidGocardlessInvitationWarnings,
  removeGocardlessInvitation
};

export default withModal(
  MODALS.REMOVE_AND_VOID_GOCARDLESS_INVITATION,
  mapStateToModalData,
  mapDispatchToModalProps
)(RemoveAndVoidGocardlessInvitationModal);
